import { Component, OnInit } from '@angular/core';
import { ServicesService } from 'src/app/services/services.service';

@Component({
  selector: 'app-contact-user-services-panel',
  templateUrl: './contact-user-services-panel.component.html',
  styleUrls: ['./contact-user-services-panel.component.scss']
})
export class ContactUserServicesPanelComponent implements OnInit {

  constructor(private services: ServicesService) { }

  ngOnInit(): void {
  }
}
